import React from 'react';
import './TermsOfServicePage.scss';

const TermsOfService = () => {
  return (
    <main className="terms-of-service">
      <section className="container">
        <h1>Terms of Service</h1>
        <p>Welcome to Canadian Broadway Monologue Contest. These terms and conditions outline the rules and regulations for the use of Canadian Broadway's Website, located at https://canadatheatre.ca.</p>
        
        <h2>1. Terms</h2>
        <p>By accessing this website we assume you accept these terms and conditions. Do not continue to use https://canadatheatre.ca if you do not agree to take all of the terms and conditions stated on this page.</p>
        
        <h2>2. Cookies</h2>
        <p>We do not collect cookies nor anything from your browser. 
          We do not track your IP. Our voting limits are based on timers and not on your IP.
          We do not collect any data apart from your email and your voting information. 
          Your email and votes will be shared with the contestant for them to be able to thank you. 
          Once the round changes, your voting information will be reset. 
          All your data will be deleted permanently once the competition is over. 
          You have an option to opt out from the competition and remove yourself at any time.</p>
        
        <h2>3. License</h2>
        <p>Unless otherwise stated, Canadian Broadway and/or its licensors own the intellectual property rights for all material on https://canadatheatre.ca. 
          All intellectual property rights are reserved. Canadian Broadway reserves the right to use your uploaded data for promotional purposes within https://canadatheatre.ca, for future competitions, to show previous winners. 
          Screenshots of https://canadatheatre.ca might also be used for promotional purposes of this competition. This data will not be used for any purposes outside Canadian Broadway Monologue Competition.</p>
        
        <h2>Contact Us</h2>
        <p>If you have any questions about our Terms of Service, please contact us at banerproductions@gmail.com.</p>
      </section>
    </main>
  );
};

export default TermsOfService;

